import React from "react";
import { Row, Col, Card } from "antd";
import styles from "../DashBoard/Subscription/YourPlan/YourPlan.module.scss";
import {
  wandaPlusIcon,
  basicPlanIcon,
  circleCheckedIcon,
} from "../../assets/images";

type Props = {
  plan: string;
  selectedPlan: string;
  handleCardClick: Function;
  wandaSubscriptionCost: any;
  wandaPlusDiscount: any;
};

const PlanCard: React.FC<Props> = ({
  plan,
  selectedPlan,
  handleCardClick,
  wandaSubscriptionCost,
  wandaPlusDiscount,
}) => {
  return (
    <Card
      id={styles.planCardContainer}
      className={`${
        plan === "Basic"
          ? styles.basicCardBackground
          : styles.plusCardBackground
      } ${selectedPlan === plan && styles.selectedCardBorder}`}
      onClick={() => handleCardClick(plan)}
    >
      <Row align="middle">
        <Col xs={5} sm={5} md={5} lg={24}>
          <Row>
            <Col lg={24} className={styles.iconsContainer}>
              {selectedPlan === plan && (
                <div className={styles.checkedIconContainer}>
                  <img
                    src={circleCheckedIcon}
                    className={styles.checkedIconImg}
                  />
                </div>
              )}
              <img
                src={`${plan === "Basic" ? basicPlanIcon : wandaPlusIcon}`}
                className={styles.planIcon}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={19} sm={19} md={19} lg={24}>
          <Row>
            <Col
              span={24}
              className={`${
                plan === "Basic" ? styles.basicPlanLabel : styles.plusPlanLabel
              }`}
            >
              {plan}
            </Col>

            <Col span={24} className={styles.planPricing}>
              ${plan === "Basic" ? 0 : wandaSubscriptionCost} / month
            </Col>

            <Col span={24} className={styles.planDetails}>
              {plan === "Basic"
                ? "Standard service fees"
                : `${wandaPlusDiscount}% OFF transportation services`}
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default PlanCard;
